const config = {
    url_api: process.env.NODE_ENV === 'production' 
      ? 'https://api2-stag.facturecr.com/facturecr-backend/public/api' 
      : '/api', // Usar proxy en desarrollo
    app_name: 'DIGITALBILL',
    version: '2.0.0'
  };
  
  export default config;
  